function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

export default {
  data: function data() {
    return {
      exportable: false,
      exportLabel: 'CSV',
      exportFile: 'output'
    };
  },
  methods: {
    initCsvExport: function initCsvExport() {
      var exportName = 'output';
      var vm = this;
      Utils.type.ifObject(this.spec["export"], function (obj) {
        vm.exportable = true;
        Utils.type.ifString(obj.label, function (val) {
          vm.exportLabel = val;
        });
        Utils.type.ifString(obj.fileName, function (val) {
          exportName = val;
        });
      });
      this.exportFile = "".concat(exportName, ".csv");
    },
    exportCsv: function exportCsv(section) {
      return 'data:text/csv;charset=' + document.characterSet + ',' + encodeURI(this._compileCsvRows(section));
    },
    _compileCsvRows: function _compileCsvRows(section) {
      var lines = [];
      lines.push(this._compileCsvRow(section.header));

      var _iterator = _createForOfIteratorHelper(section.rows),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var row = _step.value;
          lines.push(this._compileCsvRow(row));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return lines.join("\n");
    },
    _compileCsvRow: function _compileCsvRow(row) {
      var _this = this;

      return row.cellViews.map(function (view) {
        return _this._escapeForCsv(view.text);
      }).join(",");
    },
    _escapeForCsv: function _escapeForCsv(text) {
      if (Utils.type.isString(text)) {
        if (text === "") {
          return '""';
        } else if (text.contains('"') || text.contains("\n") || text.contains("\r") || text.contains(",")) {
          return '"' + text.replace(/"/g, '""') + '"';
        }

        return text;
      }

      return '""';
    }
  }
};